import { useLazyQuery } from "@apollo/client";
import React, { createContext, useContext, useRef, useState } from "react";
import { FSP_WALLET } from "../GraphApi/EqupPlans/Plan";
import { currentTeamId, hasAffiliate } from "../Utils/utils";
import { AuthContext } from "./AuthContext";

export const MyWalletContext = createContext(null);

export const MyWalletProvider = ({ children }) => {
  const [walletAmount, setWalletAmount] = useState(0);
  const [error, setError] = useState(null);
  const inFlightWalletRequest = useRef(null);
  const inFlightWalletKey = useRef(null);

  const { userData } = useContext(AuthContext);

  const [getWallet] = useLazyQuery(FSP_WALLET, {
    fetchPolicy: "network-only",
  });

  const fetchWallet = (type = "user") => {
    if (!userData?.authenticated || hasAffiliate(userData) || !currentTeamId) {
      return Promise.resolve(null);
    }

    const requestKey = `${currentTeamId}:${type}`;
    if (
      inFlightWalletRequest.current &&
      inFlightWalletKey.current === requestKey
    ) {
      return inFlightWalletRequest.current;
    }

    const request = getWallet({
      variables: { team_id: currentTeamId, type: type },
      fetchPolicy: "network-only",
    })
      .then((result) => {
        if (result?.data?.getWallet?.credit > 0) {
          setWalletAmount(parseFloat(result.data.getWallet.credit, 2));
        } else {
          setWalletAmount(0);
        }
        return result;
      })
      .catch((queryError) => {
        setError(queryError);
        return null;
      })
      .finally(() => {
        inFlightWalletRequest.current = null;
        inFlightWalletKey.current = null;
      });

    inFlightWalletRequest.current = request;
    inFlightWalletKey.current = requestKey;

    return request;
  };

  const value = {
    walletAmount: walletAmount,
    fetchWallet: fetchWallet,
    walletError: error,
  };

  return (
    <MyWalletContext.Provider value={value}>
      {children}
    </MyWalletContext.Provider>
  );
};
